<script lang="ts">
  import { onMount } from 'svelte'
  import Navbar from '@/components/appDriver/Navbar.svelte'
  import PageHome from '@/components/appDriver/PageHome.svelte'
  import { currentPage, enquiryResult, topupPaymentGatewayResult, topupRequest, topupResult } from '@/components/appDriver/store'
  import dayjs from 'dayjs'

  onMount(() => {
    $currentPage = 'topup-success'
  })

  function formatPaidAt(paidAt: string | undefined): string {
    const parsed = dayjs(paidAt)

    if (parsed.isValid()) {
      return parsed.format('DD/MM/YYYY HH:mm:ss')
    }

    return ['onepay', 'thaiqr'].includes($topupPaymentGatewayResult?.channel ?? '') ? '—' : 'Invalid Date'
  }

  async function goBack() {
    $topupRequest = {
      channel: '',
      amount: 0,
      lastAppointmentBookingId: null,
    }
    $topupPaymentGatewayResult = null
    $topupResult = null
    PubSub.publish('DRIVER.CHANGE_PAGE', { component: PageHome })
  }
</script>

<div class="page flex flex-col h-full bg-[#EFEFEF]">

  <Navbar showBack={true} on:back={goBack}/>

  <img src="{new URL('@/assets/general/loca-logo-horizontal.png', import.meta.url).href}" width="100" class="-mt-10 mx-auto">

  <main class="flex-1 overflow-y-scroll px-4">

    <div class="bg-white rounded-lg shadow divide-y divide-gray-100">

      <div class="mt-4 py-8 px-4 space-y-6">
        <div class="text-xl text-center font-semibold">ຊຳລະສຳເລັດ</div>
        <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 123.46 123.46" class="w-max mx-auto">
          <g id="Group_2331" data-name="Group 2331" transform="translate(-362 -117.084)">
            <g id="Group_2329" data-name="Group 2329" transform="translate(362 117.084)">
              <rect id="Rectangle_164" data-name="Rectangle 164" width="95.122" height="72.062" transform="translate(14.412 28.582)" fill="#fff"/>
              <path id="Icon_awesome-check-circle" data-name="Icon awesome-check-circle" d="M124.023,62.293A61.73,61.73,0,1,1,62.293.562,61.73,61.73,0,0,1,124.023,62.293ZM55.152,94.978l45.8-45.8a3.983,3.983,0,0,0,0-5.632L95.32,37.914a3.982,3.982,0,0,0-5.632,0L52.336,75.265,34.9,57.827a3.983,3.983,0,0,0-5.632,0l-5.632,5.632a3.983,3.983,0,0,0,0,5.632L49.52,94.978a3.983,3.983,0,0,0,5.632,0Z" transform="translate(-0.563 -0.563)" fill="#037e20"/>
            </g>
          </g>
        </svg>
        <div class="text-[#037E20] text-2xl text-center font-bold">LAK {$topupResult?.amount.toLocaleString()}</div>
      </div>

      <div class="p-4 flex items-center justify-between space-x-4">
        <div>
          <div class="text-sm font-light">ຄົນຂັບ</div>
          <div class="font-bold">{$enquiryResult.user.name}</div>
        </div>

        {#if $topupPaymentGatewayResult?.channel === 'unionpay'}
          <img src="{new URL('@/assets/general/payment-unionpay.png', import.meta.url).href}" width="60" height="60" class="mx-auto object-contain" alt="UnionPay">
        {:else if $topupPaymentGatewayResult?.channel === 'onepay'}
          <img src="{new URL('@/assets/general/onepay-logo.png', import.meta.url).href}" width="60" height="60" class="mx-auto">
        {:else if $topupPaymentGatewayResult?.channel === 'gln'}
          <img src="{new URL('@/assets/general/gln-logo.png', import.meta.url).href}" width="60" height="60" class="mx-auto">
        {:else if $topupPaymentGatewayResult?.channel === 'jdb'}
          <img src="{new URL('@/assets/general/jdb-yes-logo.png', import.meta.url).href}" width="60" height="60" class="mx-auto rounded-lg">
        {:else if $topupPaymentGatewayResult?.channel === 'locapay'}
          <img src="{new URL('@/assets/general/LAOQR-logo.png', import.meta.url).href}" width="60" height="60" class="mx-auto">
        {/if}

      </div>

      <div class="p-4">
        <div class="text-sm font-light">ວັນທີ</div>
        <div class="font-bold">{formatPaidAt($topupResult?.paidAt)}</div>
      </div>

      <div class="p-4">
        <div class="text-sm font-light">ເລກອ້າງອີງ</div>
        <div class="font-bold">{$topupPaymentGatewayResult?.billNumber}</div>
      </div>

      <div class="p-4">
        <div class="text-sm font-light">ເລກບິນ</div>
        <div class="font-bold">{$topupResult?.paymentRef}</div>
      </div>

    </div>

  </main>

  <div class="h-14 bg-[#1D3549] mt-auto flex justify-center items-center text-white text-xl font-semibold" on:click={goBack}>ສຳເລັດ</div>

</div>
